import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from 'components/button';
import { useTranslation } from 'react-i18next';

const NewCommentButton = ({ toggleFormAction }) => {
  const { t } = useTranslation();

  return (
    <Button onClick={toggleFormAction} secondary={true}>
      {t('new_comment')}
    </Button>
  );
};

NewCommentButton.propTypes = {
  toggleFormAction: PropTypes.func.isRequired,
};

export { NewCommentButton };
